import React, { useContext } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Beforeunload } from 'react-beforeunload';
import WabliAppBar from '../WabliAppbar/WabliAppBar';
import WabliBreadcrumb from '../WabliBreadcrumb';
import AuthContext from '../AppAuthContext';
import GeneralBody from './GeneralBody';

const CreateProject = () => {
  const { state } = useContext(AuthContext);
  const location = useLocation();

  if (!state.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <div>
        <WabliAppBar />
        <WabliBreadcrumb
          name={location.state.reason !== 'edit' ? 'create new project' : 'edit project'}
        />
        <GeneralBody />
      </div>
      <Beforeunload onBeforeunload={(event) => event.preventDefault()} />
    </>
  );
};

export default CreateProject;
